<template>
  <div class="family-home-page">
    <Header :rightIcons="false" :pageTitle="'家族通話'" />
    <div class="family-home-content">
      <div class="family-home-card">
        <p class="family-home-label">通話先</p>
        <p class="family-home-name">{{ patientName }}</p>
        <p class="family-home-desc">
          ご家族用アカウントです。患者様に音声通話またはビデオ通話を開始できます。
        </p>
      </div>

      <div class="family-home-actions">
        <van-button
          block
          round
          type="primary"
          color="#3B82C4"
          class="family-home-button"
          @click="startAudioCall"
        >
          音声通話
        </van-button>
        <van-button
          block
          round
          plain
          color="#3B82C4"
          class="family-home-button"
          @click="startVideoCall"
        >
          ビデオ通話
        </van-button>
      </div>

      <van-button
        block
        round
        plain
        color="#7B8794"
        class="family-home-logout"
        @click="signOut"
      >
        ログアウト
      </van-button>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { RefreshUserInfo } from "@/services/login";
import { LoginedOut, Logout } from "@/services/user";
import { Dialog, Toast } from "vant";
import "vant/es/dialog/style";
import "vant/es/toast/style";
import Janus from "@/assets/js/janus";

export default {
  name: "FamilyHome",
  components: {
    Header,
  },
  emits: ["callUser"],
  data() {
    return {
      userInfo: {
        patient_id: "",
        patient_name: "",
      },
    };
  },
  computed: {
    patientName() {
      return this.userInfo.patient_name || "連携患者未設定";
    },
  },
  mounted() {
    this.restoreUserInfo();
    this.syncUserInfo();
  },
  methods: {
    restoreUserInfo() {
      try {
        const userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        if (userInfo) {
          this.userInfo = userInfo;
        }
      } catch (error) {
        this.userInfo = {
          patient_id: "",
          patient_name: "",
        };
      }
    },
    async syncUserInfo() {
      const res = await RefreshUserInfo();
      if (res?.data?.code >= 0 && res?.data?.data?.user) {
        this.userInfo = res.data.data.user;
        localStorage.setItem(
          process.env.VUE_APP_USER_KEY,
          JSON.stringify(this.userInfo)
        );
      }
    },
    buildChooseItem() {
      if (!this.userInfo.patient_id) {
        Toast.fail("連携患者が見つかりません。");
        return null;
      }
      return {
        id: this.userInfo.patient_id,
        type: "patient",
        name: this.userInfo.patient_name,
      };
    },
    startAudioCall() {
      const chooseItem = this.buildChooseItem();
      if (!chooseItem) {
        return;
      }
      this.$emit("callUser", "audio", chooseItem, true, false);
    },
    startVideoCall() {
      const chooseItem = this.buildChooseItem();
      if (!chooseItem) {
        return;
      }
      this.$router.push({
        path: "/beforeCall",
        query: {
          type: chooseItem.type,
          chooseItem_id: chooseItem.id,
        },
      });
    },
    signOut() {
      Dialog.confirm({
        title: "ログアウトしますか？",
      })
        .then(() => {
          LoginedOut({ token: localStorage.getItem("refreshtoken") }).then(
            () => {
              const code = localStorage.getItem(process.env.VUE_APP_CODE_KEY);
              Logout();
              if (Janus) {
                Janus.videoPageDestory();
              }
              this.$router.push({
                path: "/login",
                query: {
                  code: code,
                },
              });
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.family-home-page {
  min-height: 100vh;
  background-color: #f4fbff;
}

.family-home-content {
  padding: 28px 20px 32px;
}

.family-home-card {
  background: #ffffff;
  border: 1px solid #dfe8f1;
  border-radius: 18px;
  padding: 24px 20px;
  box-shadow: 0 10px 24px rgba(59, 130, 196, 0.08);
}

.family-home-label {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  letter-spacing: 0.08em;
}

.family-home-name {
  margin: 10px 0 0;
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.4;
  word-break: break-word;
}

.family-home-desc {
  margin: 14px 0 0;
  font-size: 14px;
  line-height: 1.8;
  color: #4b5563;
}

.family-home-actions {
  margin-top: 28px;
}

.family-home-button {
  height: 52px;
  font-size: 17px;
}

.family-home-button + .family-home-button {
  margin-top: 14px;
}

.family-home-logout {
  margin-top: 28px;
  height: 48px;
  font-size: 15px;
}
</style>
